import * as React from 'react'
// libs
import { Field, WrappedFieldProps } from 'redux-form'
// components
import Checkbox, { CheckboxProps } from 'components/FormElements/Checkbox/index'

interface Props extends CheckboxProps {
  handleOnChange?: (event: React.ChangeEvent<HTMLInputElement>, input: WrappedFieldProps['input']) => void
}

const renderComponent = ({ meta, input, handleOnChange, ...rest }: Props & WrappedFieldProps) => {
  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    input.onChange(event.target.checked)
    handleOnChange?.(event, input)
  }

  return <Checkbox name={input.name} checked={input.value} onChange={onChange} {...rest} />
}

const ReduxCheckbox: React.FC<Props> = ({ name, ...rest }) => (
  <Field {...rest} name={name} component={renderComponent} />
)

export default ReduxCheckbox
